import { today, formatDate, isSameDay, isBefore } from '@perch-labs/warbler';
import { copyFor } from 'config';
import { getSolarProjectName } from 'utils/format';
import SolarPanelsImage from '/images/solar-panels.png';
import { Props as ProjectDetailsProps } from 'pages/solar/components/project-details/project-details.component';

const getProjectDetailsCopy = copyFor('solar.projectDetails.active');

export interface Project {
  city: string | null;
  name: string;
  startDate: Date;
  image?: {
    thumbnail: string;
  };
  utility: {
    state: {
      abbreviation: string;
    };
  };
  mdIdentifier: string | null;
}

export const getProjectDetailsProps = (
  project: Project
): ProjectDetailsProps => {
  let description: string | undefined;
  if (isBefore(project.startDate, today())) {
    description = isSameDay(today(), project.startDate)
      ? getProjectDetailsCopy('description.onStartDate')
      : getProjectDetailsCopy('description.afterStartDate', {
          date: formatDate(project.startDate, { format: 'MMMM yyyy' }),
        });
  }
  const location = project.city
    ? getProjectDetailsCopy('location.includesCity', {
        city: project.city,
        state: project.utility.state.abbreviation,
      })
    : getProjectDetailsCopy('location.excludesCity', {
        state: project.utility.state.abbreviation,
      });

  return {
    description,
    imageSrc: SolarPanelsImage,
    svgSrc: project.image?.thumbnail,
    location,
    title: getSolarProjectName(project.name),
    mdIdentifier: project.mdIdentifier,
  };
};
